import { Component, input } from '@angular/core';
import { IonCardSubtitle } from '@ionic/angular/standalone';

@Component({
  selector: 'x-card-subtitle',
  imports: [IonCardSubtitle],
  templateUrl: './x-card-subtitle.component.html',
  styleUrl: './x-card-subtitle.component.scss',
})
export class XCardSubtitleComponent {
  cssClass = input<string>('');
}
